import { useBackNavigation } from '@/shared/lib/navigation/BackNavigationContext';

const BackArrowIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </svg>
);

interface BackButtonProps {
  onClick?: () => void;
}

export function BackButton({ onClick }: BackButtonProps) {
  const { triggerBack } = useBackNavigation();

  return (
    <div style={{ position: 'relative', height: 50 }}>
      <button
        onClick={onClick ?? triggerBack}
        style={{
          position: 'absolute',
          top: 12,
          left: 12,
          height: 40,
          padding: '0 16px',
          borderRadius: 20,
          border: '1px solid var(--theme-border)',
          background: 'var(--theme-bg-elevated)',
          color: 'var(--theme-text)',
          fontSize: 14,
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          cursor: 'pointer',
          zIndex: 50,
          fontFamily: 'inherit',
          transition: 'all 0.2s ease',
        }}
        aria-label="Назад"
      >
        <BackArrowIcon />
        <span>Назад</span>
      </button>
    </div>
  );
}
